import { Box, BoxProps } from '@mui/material'
import { ReactNode } from 'react'

type CenterProps = {
  children: ReactNode
  sx?: BoxProps['sx']
}

const Center = ({ children, sx }: CenterProps) => (
  <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flex: 1, ...sx }}>{children}</Box>
)

export default Center
